import { render } from "./resume.vue?vue&type=template&id=9e5f708a&scoped=true"
import script from "./resume.vue?vue&type=script&lang=js"
export * from "./resume.vue?vue&type=script&lang=js"

import "./resume.vue?vue&type=style&index=0&id=9e5f708a&scoped=true&lang=css"

import exportComponent from "/home/dre/personalsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e5f708a"]])

export default __exports__